import { HelpCircle } from "lucide-react";
import { useLocation } from "react-router-dom";
import PAGES from "@/lib/guidePages.json";

const ROUTES = [["/customers/", "customer_detail"], ["/invoice/", "invoice"], ["/confirmations", "confirmations"], ["/production", "production"],
  ["/materials", "materials"], ["/products", "products"], ["/customers", "customers"], ["/societies", "societies"], ["/deliveries", "deliveries"],
  ["/credit", "credit"], ["/insights", "insights"], ["/leads", "leads"], ["/gst", "gst"], ["/offers", "offers"], ["/signups", "join"],
  ["/team", "team"], ["/settings", "settings"], ["/bugs", "bugs"], ["/delivery", "delivery_app"]];

export const guideHref = (path) => {
  const hit = ROUTES.find(([p]) => path.startsWith(p));
  const key = hit ? hit[1] : path === "/" ? "dashboard" : null;
  return `/NexFresh_System_Guide.pdf${key && PAGES[key] ? `#page=${PAGES[key]}` : ""}`;
};

export const HelpButton = ({ className = "" }) => {
  const { pathname } = useLocation();
  return (
    <a href={guideHref(pathname)} target="_blank" rel="noreferrer" title="How this screen works (guide)" aria-label="Help for this screen"
      className={`group fixed bottom-4 right-4 z-40 flex h-10 w-10 items-center justify-center rounded-full bg-[#0F382C]/90 text-white shadow-lg ring-4 ring-[#FBF9F4] transition-transform hover:scale-105 hover:bg-[#134E3A] sm:bottom-5 sm:right-5 sm:h-12 sm:w-12 ${className}`}
      data-testid="help-guide-btn">
      <HelpCircle className="h-6 w-6" />
      <span className="pointer-events-none absolute right-14 whitespace-nowrap rounded-lg bg-[#0F382C] px-2.5 py-1 text-xs font-medium opacity-0 transition-opacity group-hover:opacity-100">How this screen works</span>
    </a>
  );
};
